import i18n from '../../plugins/i18n';
import { changedByObject } from '../../helpers/transformToPresentableData';
import { formatCommissioningContactPerson } from '../../helpers/commissioningContactPerson';

function formatAddress(address = {}) {
  const street = [address.street, address.street_number]
    .filter(Boolean)
    .join(' ');
  const city = [address.zip, address.city].filter(Boolean).join(' ');

  return [street, city].filter(Boolean).join(', ') || '-';
}

function applicantName(order) {
  if (order.applicant_name) {
    return order.applicant_name;
  }

  const applicant = order.applicant || order.payload?.contact_person;
  return formatCommissioningContactPerson(applicant);
}

export function sealingTableOrderMapper(order = {}) {
  return {
    orderId: order.id,
    date: order.request_date ? new Date(order.request_date) : null,
    applicant: applicantName(order),
    product: i18n.t('sealing.product'),
    address: formatAddress(
      order.product_installation_full_address ||
        order.connection_address ||
        order.payload?.connection_address
    ),
    sealingReason: order.sealing_reason || order.payload?.sealing_reason || '-',
    lastChangedBy: changedByObject(order),
  };
}
